import { render } from "./UltraAction.vue?vue&type=template&id=092da87e&scoped=true"
import script from "./UltraAction.vue?vue&type=script&lang=js"
export * from "./UltraAction.vue?vue&type=script&lang=js"

import "./UltraAction.vue?vue&type=style&index=0&id=092da87e&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-092da87e"]])

export default __exports__